import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import {
  ApprovalDto,
  ApprovalDetailDto,
  DetectedFileInfo,
  DownloadHistoryInfo,
  FileDetailsInfo,
  FileInfoDto,
} from './approvalApi';

const FXM_API_URL = config.servers.fxm.url;
export interface DecryptApprovalDto extends ApprovalDto {
  approvalNo: string;
  submission: string;
}

export interface DecryptApprovalDetailDto extends ApprovalDetailDto {
  submission: string;
  fileDetails: FileDetailsInfo[];
  downloadHistory: DownloadHistoryInfo[];
  detectedFiles?: DetectedFileInfo[];
}
export type DecryptApprovalDetailEntity = DecryptApprovalDetailDto;
export const toDecryptApprovalDetailDtoToEntity = (
  dto: DecryptApprovalDetailDto
): DecryptApprovalDetailEntity => {
  return {
    ...dto,
    progressApprovers: dto.progressApprovers === null ? [] : dto.progressApprovers,
    completeApprovers: dto.completeApprovers === null ? [] : dto.completeApprovers,
  };
};
export type DecryptApprovalReqDto = DecryptApprovalDto;
export interface ApplyGenKeyDto {
  approvalNo: string;
}
interface DecryptApprovalApi {
  find(approvalNo: string): Promise<DecryptApprovalDetailEntity>; // 사용자 > 내 신청함 > 결재 완료 이외 부분에서 사용하는 API
  find2(approvalNo: string): Promise<DecryptApprovalDetailEntity>; // 사용자 > 내 신청함 > 결재완료에서 사용 하는 API
  getGenKey(): Promise<ApplyGenKeyDto>;
  fileUpload(
    approvalNo: string,
    code: string,
    files: File[],
    progressConfig: {
      onUploadProgress: (progressEvent: any) => void;
    }
  ): Promise<FileInfoDto[]>;
  deleteUploadFile(approvalNo: string, fileUuid: string): Promise<FileInfoDto>;
  deleteUploadFiles(approvalNo: string, fileUuids: string[]): Promise<FileInfoDto[]>;
  apply(reqDto: DecryptApprovalReqDto): Promise<DecryptApprovalDetailDto>;
  cancel(approvalNo: string): Promise<boolean>;
}
class DecryptApprovalServerApi implements DecryptApprovalApi {
  async find(approvalNo: string): Promise<DecryptApprovalDetailEntity> {
    const resp = await axios.get<DecryptApprovalDetailDto>(
      `${FXM_API_URL}/api/decrypt/find/${approvalNo}`
    );
    return toDecryptApprovalDetailDtoToEntity(resp.data);
  }
  async find2(approvalNo: string): Promise<DecryptApprovalDetailEntity> {
    const resp = await axios.get<DecryptApprovalDetailDto>(
      `${FXM_API_URL}/api/decrypt/find2/${approvalNo}`
    );
    return toDecryptApprovalDetailDtoToEntity(resp.data);
  }
  async getGenKey(): Promise<ApplyGenKeyDto> {
    const resp = await axios.get<ApplyGenKeyDto>(`${FXM_API_URL}/api/genkey`);
    return resp.data;
  }
  async fileUpload(
    approvalNo: string,
    code: string,
    files: File[],
    progressConfig: {
      onUploadProgress: (progressEvent: any) => void;
    }
  ): Promise<FileInfoDto[]> {
    const form = new FormData();
    form.append('approvalType', 'DECRYPT');
    form.append('approvalNo', approvalNo);
    form.append('code', code);
    files.map((file) => form.append('files', file));

    const resp = await axios.post<FileInfoDto[]>(
      `${FXM_API_URL}/api/decrypt/upload`,
      form,
      progressConfig
    );

    return resp.data;
  }

  async deleteUploadFile(approvalNo: string, fileUuid: string): Promise<FileInfoDto> {
    const resp = await axios.get<FileInfoDto>(
      `${FXM_API_URL}/api/decrypt/delete/one/${approvalNo}/${fileUuid}`
    );
    return resp.data;
  }
  async deleteUploadFiles(approvalNo: string, fileUuids: string[]): Promise<FileInfoDto[]> {
    const resp = await axios.post<FileInfoDto[]>(
      `${FXM_API_URL}/api/decrypt/delete/many/${approvalNo}`,
      fileUuids
    );
    return resp.data;
  }

  async apply(reqDto: DecryptApprovalReqDto): Promise<DecryptApprovalDetailDto> {
    const resp = await axios.post<DecryptApprovalDetailDto>(
      `${FXM_API_URL}/api/decrypt/apply`,
      reqDto
    );
    return resp.data;
  }

  async cancel(approvalNo: string): Promise<boolean> {
    await axios.get<DecryptApprovalDetailDto>(`${FXM_API_URL}/api/decrypt/cancel/${approvalNo}`);
    return true;
  }
}
const decryptApprovalApi = new DecryptApprovalServerApi();
export default decryptApprovalApi;
